// WHAT WE ASKED THE CLIENT FOR — its own column beside what the cost was, so the two
// figures read side by side. Display only: every figure here is one the server sent.
//
// Raised: the invoice's own amount — when it differs from the planned charge, the invoice
// is the one that is true. Not raised yet: the planned charge, or that none is set.
// Absorbed, unstated, or a cancelled charge: nothing was asked, so a dash. No date: the
// expense tables carry none, and when the charge is due is the money screen's question.
import he from '../i18n/he';
import Money from './Money';
import { isChargedOn, isCharged } from '../utils/expenses';

export default function AskedCell({ expense }) {
  if (!isChargedOn(expense)) return '—';
  if (isCharged(expense)) {
    const collection = expense.charge_collection;
    if ((collection && collection.cancelled) || expense.charged_invoice_amount == null) return '—';
    return <Money value={expense.charged_invoice_amount} className="amount-strong" />;
  }
  return expense.charge_amount != null
    ? <Money value={expense.charge_amount} className="amount-strong" />
    : <span className="muted">{he.expenses.chargeNotSet}</span>;
}
